import { on, events } from '@estee/elc-service-bus';
import { IErrorMessage } from '../internal/views/common/ErrorPanel';
import { diContainer, serviceNames } from './diContainer';
import { UserRepository } from '../internal/repositories/UserRepository';

export class ServiceBusController {
    @on(events.RAMP_LOG_IN_FAILED)
    public handleFailedRampLogIn = ({ errors }: { errors?: IErrorMessage[] }) => {
        const userRepository: UserRepository = diContainer.get(serviceNames.userRepository);
        if (errors) {
            userRepository.setErrorMessages(errors);
        }
    };
}
